import { PromoterModel } from '@mm/state/model/PromoterModel';
import { usePromoterCRUDActions } from '@mm/state/actions/PromoterCRUDActions';
import { useChatbotCRUDActions } from '@mm/state/actions/ChatbotCRUDActions';
import { useSelector } from 'react-redux';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import { useEffect, useState } from 'react';

const getInitialLocalPromoter = (promoter: PromoterModel | undefined) => {
  if (!promoter) {
    return;
  }
  return {
    ...promoter,
    hideDesktop: promoter.hideDesktop || false,
    hideMobile: promoter.hideMobile || false,
    hideForNewVisitors: promoter.hideForNewVisitors || false,
    hideForExistingVisitors: promoter.hideForExistingVisitors || false,
    conditions: promoter.conditions || {
      ruleMode: 'any',
      rules: [{ operator: '*', value: '' }],
    },
  };
};
export const useCustomerChatConditionsEditorPromoterState = (
  promoter: PromoterModel | undefined,
) => {
  const promoterCRUDActions = usePromoterCRUDActions();
  const chatbotCRUDActions = useChatbotCRUDActions();

  const { id: botId } = useSelector(activeChatbotSelector);

  const [localPromoter, setLocalPromoter] = useState(
    getInitialLocalPromoter(promoter),
  );
  const updatePromoter = (updatedPromoter: PromoterModel) => {
    chatbotCRUDActions.updateSetupStepsRemainingByPageIdUpdated(
      updatedPromoter.pageId,
    );
    return promoterCRUDActions.update(botId, updatedPromoter);
  };

  useEffect(() => {
    setLocalPromoter(getInitialLocalPromoter(promoter));
  }, [promoter]);

  const updateLocalPromoterField = <K extends keyof PromoterModel>(
    key: K,
    value: PromoterModel[K],
  ) => {
    if (!localPromoter) {
      return;
    }
    const updatedPromoter = { ...localPromoter, [key]: value };
    setLocalPromoter(updatedPromoter);
    updatePromoter(updatedPromoter);

    return updatedPromoter;
  };
  return {
    localPromoter,
    setLocalPromoter,
    updatePromoter,
    updateLocalPromoterField,
  };
};
